import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import PrincipalHistorizationPreviewViewModel from '@/ViewModels/Controls/PrincipalHistorizationPreviewViewModel';
import PrincipalHistorizationPreview from '@/Controls/PrincipalHistorizationPreview';

export default class PrincipalHistorizationPreviewFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private PrincipalHistorizationPreviewViewModel = ComponentManager.getViewModel<typeof PrincipalHistorizationPreviewViewModel>('PrincipalHistorizationPreviewViewModel');
    private PrincipalHistorizationPreview = ComponentManager.getControl<typeof PrincipalHistorizationPreview>('PrincipalHistorizationPreview');

    /**
     * @override
     */
    public viewModel: PrincipalHistorizationPreviewViewModel;

    public constructor(params: any) {
        super(params);
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = new this.PrincipalHistorizationPreviewViewModel({
            parentLocator: this.locator,
            locator: this.detailViewItem.name,
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            invalidationText: this.invalidationText
        });

        this.control = new this.PrincipalHistorizationPreview(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        return this.jQueryControl;
    }
}

ComponentManager.setFactory('PrincipalHistorizationPreview', PrincipalHistorizationPreviewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');